import React, { useEffect, useState, useRef, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import moment from "moment";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import * as API from "../../libs/service";
import routes from "../../libs/routes";
// import consts from '../../libs/consts';

import { logIn, logOut } from "../../redux/usersSlice";
import { open, close } from "../../redux/popupSlice";
import { loadingStart, loadingEnd } from "../../redux/loadingSlice";

import Popup01 from "../popup/Popup01"

export default function Popup02(props) {
    const {
        title,
        subTitle,
        text,
        lefttext,
        width,
        button,
        buttonCancel,
        func,
        setFunc,
        noneLoading,
        top,
        cancelFunc,
        x_btn,
        cancelText,
        longButton,
        text1,
        text2,
        text3,
        text1_b,
        text2_b,
        text3_b,
        loginPop_navi_pw,
        loginPop_navi_google,
        register_term1,
        register_term2,
        register_term3,
        cardOffTest,
        maxwidth
    } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const lang = useSelector(state => state.langReducer.lang);
    const { mbData } = useSelector((s) => s.usersReducer);
    const [cardOffTestEmail, setCardOffTestEmail] = useState('')
    const [cardOffTestEmailSuc, setCardOffTestEmailSuc] = useState(false)

    const terms = useSelector((s) => s.etcReducer.terms);
    console.log("terms : ", terms);
    const serviceTerms = terms?.Terms?.[lang === 0 ? 'ko' : 'en']?.content || ''
    const privacy = terms?.Collection?.[lang === 0 ? 'ko' : 'en']?.content || ''
    const marketing = terms?.Marketing?.[lang === 0 ? 'ko' : 'en']?.content || ''

    const serviceTermsSub = terms?.Terms?.[lang === 0 ? 'ko' : 'en']?.sub || ''
    const privacySub = terms?.Collection?.[lang === 0 ? 'ko' : 'en']?.sub || ''
    const marketingSub = terms?.Marketing?.[lang === 0 ? 'ko' : 'en']?.sub || ''

    useEffect(() => {
        if (!buttonCancel && !button && top) {
            const popup = document.querySelector(".popup.show");
            /* console.log(popup); */
            if (popup) popup.classList.add("popup_top");
            const timeout = setTimeout(() => {
                dispatch(close());
            }, 1000);
            popup.addEventListener("click", () => {
                dispatch(close());
                clearTimeout(timeout);
            });
        }
    }, []);

    const setFunction = () => {
        if (setFunc) setFunc();
        dispatch(close());
    };

    const InputChange = (event) => {
        const { name, value } = event.target;

        if (name === "card_off_test_email") {
            let EmailChk = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            setCardOffTestEmail(value)

            if (!EmailChk.test(value)) {
                setCardOffTestEmailSuc(false);
                return;
            }

            if (value && EmailChk.test(value)) {
                setCardOffTestEmailSuc(true);
            } else {
                setCardOffTestEmailSuc(false);
            }
        }
    }

    const CardOffEmailFunc = async () => { // 이메일 발송 테스트 API
        let sender = {
            idx: mbData?.idx,
            user_email: cardOffTestEmail,
            license_key: 'AABBCCDD1234'
        };

        /* console.log('sender', sender);
        return; */
        dispatch(loadingStart());

        await API.post('v1/mypage/CardOffEmail', sender).then(({ data }) => {
            /* console.log('체크', data); */

            dispatch(loadingEnd());
            dispatch(open({
                component:
                    <Popup01
                        max_width={'300px'}
                        x_btn={false}
                        text1={lang === 0 ? '메일을 발송했습니다.' : 'Email sent.'}
                        longButton={lang === 0 ? '확인' : 'OK'}
                    />
            }));

        }).catch(err => {
            /* console.log(err.response.data); */
            dispatch(loadingEnd());
            dispatch(open({
                component:
                    <Popup01
                        x_btn={false}
                        text1={lang === 0 ? '오류가 발생했습니다.' : 'An error occurred.'}
                        longButton={lang === 0 ? '확인' : 'OK'}
                    />
            }));
        }).finally(() => {

        })
    }

    return (
        <>
            <div
                className={"popup_default01 regi_term"}
                style={{
                    maxWidth: maxwidth ? '800px' : '480px',
                    width: '100%',
                    marginLeft: 10,
                    marginRight: 10,
                    height: cardOffTest ? 'unset' : '',
                    maxHeight: cardOffTest ? 'unset' : ''
                }}
            >
                {x_btn &&
                    <div className="popup_x_btn_box term">
                        {register_term1 && <p className="term_title">{serviceTermsSub}</p>}
                        {register_term2 && <p className="term_title">{privacySub}</p>}
                        {register_term3 && <p className="term_title">{marketingSub}</p>}

                        <img src={require("../../assets/images/exit-icon.svg").default}
                            className="popup_x_btn"
                            onClick={() => {
                                dispatch(close());
                            }}
                            style={{ cursor: isBrowser ? 'pointer' : 'auto' }}
                        />
                        <div style={{ height: 16 }} />
                    </div>
                }
                <div className="popup_content_box" style={{ paddingTop: (register_term1 || register_term2 || register_term3) && '0' }}>
                    {text1 &&
                        <div
                            className="popup_text_box"
                        >
                            <p>{text1}</p>
                        </div>
                    }

                    {text1_b && // 마진 위아래 있음
                        <div
                            className="popup_text_box mar"
                        >
                            <b>{text1_b}</b>
                        </div>
                    }

                    {text2 &&
                        <div
                            className="popup_text_box"
                        >
                            <p>{text2}</p>
                        </div>
                    }

                    {text2_b &&
                        <div
                            className="popup_text_box"
                        >
                            <b>{text2_b}</b>
                        </div>
                    }

                    {text3 &&
                        <div
                            className="popup_text_box"
                        >
                            <p>{text3}</p>
                        </div>
                    }

                    {text3_b &&
                        <div
                            className="popup_text_box"
                        >
                            <b>{text3_b}</b>
                        </div>
                    }

                    {loginPop_navi_pw && // 이메일 가입된 계정 팝업
                        <div
                            className="popup_text_box navi_pw"
                        >
                            <p onClick={() => { }}>
                                {lang === 0 ? '비밀번호 변경' : 'Change Password'}
                            </p>
                            <span>{lang === 0 ? '이 필요합니다' : 'is required'}</span>
                        </div>
                    }

                    {loginPop_navi_google && // 이메일 가입된 계정 팝업
                        <div
                            className="popup_text_box navi_google"
                        >
                            <p>{lang === 0 ? '구글로 가입된 계정입니다.' : 'This account is registered with Google.'}</p>
                            <button
                                type="button"
                                className="sns_login_btn google"
                                style={{ marginTop: '32px' }}
                            >
                                <img src={require("../../assets/icon/google.svg").default} />
                                {lang === 0 ? '구글 로그인' : 'Google Login'}
                            </button>
                        </div>
                    }

                    {register_term1 && // 회원가입 서비스 이용약관
                        <div
                            className="popup_term_box"
                        >
                            {/* <p className="term_title">서비스 이용약관</p> */}
                            <div className="term_text"
                                dangerouslySetInnerHTML={{ __html: serviceTerms }}
                            />
                        </div>
                    }

                    {register_term2 && // 개인정보 수집 및 이용 동의 약관
                        <div
                            className="popup_term_box"
                        >
                            {/* <p className="term_title">개인정보 수집 및 이용 동의</p> */}
                            <div className="term_text"
                                dangerouslySetInnerHTML={{ __html: privacy }}
                            />
                        </div>
                    }

                    {register_term3 && // 마케팅 정보 수신 동의 약관
                        <div
                            className="popup_term_box"
                        >
                            {/* <p className="term_title">마케팅 정보 수신 동의</p> */}
                            <div className="term_text"
                                dangerouslySetInnerHTML={{ __html: marketing }}
                            />
                        </div>
                    }

                    {title &&
                        <div
                            className="popup_title_box"
                        >
                            <p>{title}</p>
                        </div>
                    }

                    {subTitle &&
                        <div
                            className="popup_sub_title_box"
                        >
                            <p>{subTitle}</p>
                        </div>
                    }
                    {text &&
                        <div
                            className="popup_text_box"
                            style={!buttonCancel && !button ? { padding: "0" } : {}}
                        >
                            <p>{text}</p>
                        </div>
                    }

                    {lefttext &&
                        <div
                            className="popup_left_text_box"
                            style={!buttonCancel && !button ? { padding: "0" } : {}}
                        >
                            <p>{lefttext}</p>
                        </div>
                    }

                    {cancelText &&
                        <div className="popup_cancel_text_box">
                            <p className="title01">{lang === 0 ? '멤버십을 취소하시면' : 'If you cancel your membership,'}</p>
                            <p className="title01" style={{ color: 'red' }}>{lang === 0 ? '드랍인 신청을 받을 수 없습니다.' : 'you cannot receive drop-in requests.'}</p>
                            <p className="title02">{lang === 0 ? '드랍인 설정은 그대로 유지됩니다.' : 'Drop-in settings remain unchanged.'}</p>
                            <p className="title03">{lang === 0 ? '멤버십을 취소하시겠습니까?' : 'Do you want to cancel your membership?'}</p>
                        </div>
                    }

                    {cardOffTest && // 테스트 이메일 발송용
                        <div className="input_box plus_member">
                            <div
                                className="input_div"
                            >
                                <input
                                    type="text"
                                    placeholder={lang === 0 ? "이메일 입력" : "Enter email"}
                                    name="card_off_test_email"
                                    onChange={InputChange}
                                    value={cardOffTestEmail}
                                />
                            </div>
                        </div>
                    }

                    {(buttonCancel || button || longButton) &&
                        <div className="popup_btn_box">
                            {buttonCancel && (
                                <button
                                    className="button_cancel"
                                    onClick={() => {
                                        if (func === "setRightFunc") {
                                            setFunction();
                                        } else {
                                            if (cancelFunc) cancelFunc();
                                            dispatch(close());
                                        }
                                    }}
                                >
                                    {buttonCancel}
                                </button>
                            )}
                            {button && (
                                <button
                                    className="button_success"
                                    onClick={() => {
                                        if (cardOffTest) {
                                            if (!cardOffTestEmailSuc) {
                                                return;
                                            } else {
                                                CardOffEmailFunc();
                                            }
                                        }

                                        if (func === "setRightFunc") {
                                            dispatch(close());
                                        } else {
                                            setFunction();
                                        }
                                    }}
                                >
                                    {button}
                                </button>
                            )}
                            {longButton && (
                                <button
                                    className="button_success long"
                                    onClick={() => {
                                        if (func === "setRightFunc") {
                                            dispatch(close());
                                        } else {
                                            setFunction();
                                        }
                                    }}
                                >
                                    {longButton}
                                </button>
                            )}
                        </div>
                    }
                </div>
            </div>
        </>
    );
}